import report from '@/api/report/finance'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  getVendor(context, attributes = {}) {
    return report.vendor()
  },
  payToVendor(context, data) {
    return report.payToVendor(data)
  },
  payToVendorExcel(context, data) {
    return report.payToVendorExcel(data)
  },
  incomeStatementDetail(context, data) {
    return report.incomeStatementDetail(data)
  },
  incomeStatementDetailExcel(context, data) {
    return report.incomeStatementDetailExcel(data)
  },
  grossProfit(context, data) {
    return report.grossProfit(data)
  },
  grossProfitExcel(context, data) {
    return report.grossProfitExcel(data)
  },
  saleByCustomerSummary(context, data) {
    return report.saleByCustomerSummary(data)
  },
  saleByCustomerSummaryToExcel(context, data) {
    return report.saleByCustomerSummaryToExcel(data)
  },
  customerProfile(context) {
    return report.customerProfile()
  },
  // generate account receivable
  accountReceivable(context, attributes = {}) {
    return report.accountReceivable({ params: attributes })
  },
  // generate account receivable
  accountReceivableExcel(context, data) {
    return report.accountReceivableExcel(data)
  },
  // generate cash collection by cashier
  cashCollectionByCashier(context, attributes = {}) {
    return report.cashCollectionByCashier({ params: attributes })
  },
  // export excel cash collection by cashier
  cashCollectionByCashierExcel(context, data) {
    return report.cashCollectionByCashierExcel(data)
  },
}